module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 77.e126353d.png";